import React, { PureComponent } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { isCollaboratorAccess } from "Utils";
import { selectLoggedAs } from "Selectors";
import classnames from "classnames";

import CollaboratorCapacityPlaningChart from "./CollaboratorCapacityPlaningChart";
import CollaboratorSpaceLargeFrame from "./CollaboratorSpaceLargeFrame";
import CollaboratorSpaceCalendar from "./CollaboratorSpaceCalendar";
import CollaboratorSpaceFilter from "./CollaboratorSpaceFilter";
import CollaboratorSpaceAside from "./CollaboratorSpaceAside";
import CollaboratorValuation from "./CollaboratorValuation";
import CollaboratorScore from "./CollaboratorScore";

import styles from "./CollaboratorSpace.local.scss";
import { clearAllCookies } from "../../utils";

class CollaboratorSpace extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      period: "ANNUAL",
      user: null,
      date: props.date ? props.date : moment(),
      year: props.date ? props.date.year() : moment().year()
    };
  }

  componentDidMount() {
    const { loggedAs, spaceAs } = this.props;
    if (isCollaboratorAccess(loggedAs, spaceAs)) {
      this.setState({ user: this.props.user });
    } else {
      this.setState({ user: this.props.collaborator });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { date, loggedAs, spaceAs } = this.props;
    if (prevProps.date !== date && !isCollaboratorAccess(loggedAs, spaceAs)) {
      this.setState({ date: date, year: date.year().toString() });
    }
  }

  handlePeriodFilterChange = (period, date, year) => {
    let newDate = date;
    let newYear = year;
    period && this.setState({ period });
    if (date) {
      newYear = date.year().toString();
    }
    if (year) {
      newDate =
        moment()
          .year()
          .toString() === year.toString()
          ? moment()
          : new moment(year + "-12-31");
    }
    this.setState({ date: newDate, year: newYear });
    this.props.onAnalyseDateChange && this.props.onAnalyseDateChange(newDate);
  };

  render() {
    let { period, date, year, user } = this.state;
    let {
      lng,
      from,
      dispatch,
      organization,
      withoutHeader,
      collaborator
    } = this.props;

    return (
      user && (
        <div
          className={classnames(
            styles.page_content,
            withoutHeader ? styles.without_header : ""
          )}
        >
          <CollaboratorSpaceAside
            user={user}
            language={lng}
            collaborator={collaborator}
            organization={organization}
          />
          <div className={styles.block_content}>
            <CollaboratorSpaceFilter
              date={date}
              period={period}
              arrivalDate={user.arrivalDate}
              onChangeFilter={this.handlePeriodFilterChange}
            />
            <div className={styles.section_block}>
              <div className={styles.principal_section}>
                <CollaboratorCapacityPlaningChart
                  user={user}
                  year={year}
                  date={date}
                  period={period}
                  dispatch={dispatch}
                  organization={organization}
                />
                <CollaboratorValuation
                  user={user}
                  date={date}
                  year={year}
                  period={period}
                  organization={organization}
                />
              </div>
              <div className={styles.second_section}>
                <CollaboratorScore
                  user={user}
                  date={date}
                  period={period}
                  organization={organization}
                />
                <CollaboratorSpaceCalendar
                  year={year}
                  date={date}
                  user={user}
                  from={from}
                  organization={organization}
                />
              </div>
            </div>
            <CollaboratorSpaceLargeFrame
              date={date}
              user={user}
              period={period}
              language={lng}
              dispatch={dispatch}
              organization={organization}
            />
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  lng: state.params.lng,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth && state.auth.spaceAs,
  organization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CollaboratorSpace);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpace.js